import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import arrowLeftSvg from 'assets/icons/arrow_left.svg';
import { Store } from 'components/common/types/Store.types';
import Button from 'lib/Button';
import { Color, Size } from 'lib/Button/Button.types';
import { isValidIndex } from 'utils/numberUtils';
import { removeAllCreatives, resetCreativeSetDetails } from 'store/pages/contentManagement/creativeSetDetails/reducer';
import IconButton from 'lib/IconButton';
import { Theme } from 'lib/IconButton/IconButton.types';

const Header = (): React.ReactElement => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const isPanelView = useSelector((state: Store) => state.pages.contentManagement.creativeSetDetails.isPanelView);
  const isNewSet = useSelector((state: Store) => state.pages.contentManagement.creativeSetDetails.isNewSet);
  const code = useSelector((state: Store) => state.pages.contentManagement.creativeSetDetails.code);

  const page = isValidIndex(location.state?.creativeSetPage) ? location.state.creativeSetPage : undefined;

  const handleRemoveAllCreatives = (): void => {
    dispatch(removeAllCreatives());
  };

  const handleResetCreativeSetDetails = (): void => {
    dispatch(resetCreativeSetDetails());
  };

  const handleBack = (): void => {
    if (page !== undefined) {
      navigate(`/content-management/creative-sets?creativeSetPage=${page}`);
    } else {
      navigate('/content-management/creative-sets');
    }
  };

  return (
    <div className="flex items-center justify-between bg-neutral-300 pl-8 py-5 pr-14">
      <div className="flex items-center">
        <IconButton
          dataTestId="back-to-creative-sets"
          name="back-to-creative-sets"
          icon={arrowLeftSvg}
          handleOnClick={handleBack}
          theme={Theme.PRIMARY}
        />
        <h2 className="ml-6 header-xl text-neutral-950">{`${isNewSet ? 'New' : code} creative set`}</h2>
      </div>
      {isPanelView && isNewSet ? (
        <div className="flex items-center space-x-2.5">
          <Button size={Size.LARGE} color={Color.PERSIAN_BLUE} onClick={handleRemoveAllCreatives}>
            Reset Creatives
          </Button>
          <Button size={Size.LARGE} onClick={handleResetCreativeSetDetails}>
            Select new VU
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default Header;
